"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.CAPTION_SAMPLES = exports.LANGUAGES = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FREE_LANGUAGES = ['EN'];
var LANGUAGES = {
  EN: 'ENGLISH (US)',
  JA: 'JAPANESE',
  AR: 'ARABIC',
  ZH: 'CHINESE',
  CS: 'CZECH',
  NL: 'DUTCH',
  FR: 'FRENCH',
  DE: 'GERMAN',
  IT: 'ITALIAN',
  KO: 'KOREAN',
  PL: 'POLISH',
  PT: 'PORTUGESE',
  RU: 'RUSSIAN',
  ES: 'SPANISH',
  TR: 'TURKISH'
};
exports.LANGUAGES = LANGUAGES;
var PREFIX_OVERRIDES = {
  EN: 'us',
  JA: 'jp',
  AR: '',
  ZH: 'ch',
  CS: 'cz',
  NL: 'du',
  KO: 'kr',
  PT: 'br'
};
var CAPTION_SAMPLES = {
  EN: 'An example subtitle',
  JA: '字幕の例',
  AR: 'مثال الترجمة',
  ZH: '一个示例字幕',
  CS: 'Příklad titulků',
  NL: 'Een voorbeeld ondertitel',
  FR: 'Un exemple de sous-titre',
  DE: 'Ein Beispiel für einen Untertitel',
  IT: 'Un sottotitolo di esempio',
  KO: '자막 예',
  PL: 'Przykładowy podtytuł',
  PT: 'Um exemplo de legenda',
  RU: 'Пример субтитра',
  ES: 'Un subtítulo de ejemplo',
  TR: 'Örnek bir altyazı'
};
exports.CAPTION_SAMPLES = CAPTION_SAMPLES;

function _default() {
  var CAPTIONS = Object.keys(LANGUAGES).map(function (languageCode) {
    return {
      label: LANGUAGES[languageCode],
      value: languageCode,
      prefix: "flag".concat(PREFIX_OVERRIDES[languageCode] || languageCode.toLowerCase()),
      suffix: FREE_LANGUAGES.includes(languageCode) ? /*#__PURE__*/_react.default.createElement("span", null, "$-") : /*#__PURE__*/_react.default.createElement("span", null, "$275.00")
    };
  });
  return CAPTIONS;
}